import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div>

      {/* HERO */}
      <section className="bg-gray-100 text-center py-20">
        <h1 className="text-5xl font-bold text-gray-800">
          Custom Design. Precision Fabrication.
        </h1>

        <p className="mt-4 text-lg text-gray-600">
          CAD/CAM | 3D Printing | Web & Mobile Development
        </p>

        <div className="mt-6 space-x-4">
          <Link to="/fabrication" className="bg-green-600 text-white px-6 py-2 rounded">
            View Products
          </Link>

          <Link to="/contact" className="bg-blue-600 text-white px-6 py-2 rounded">
            Request Quote
          </Link>
        </div>
      </section>

      {/* SERVICES */}
      <section className="py-16 px-6">
        <h2 className="text-3xl font-bold text-center mb-10">
          Our Services
        </h2>

        <div className="grid md:grid-cols-3 gap-6">

          <div className="p-6 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Engineering</h3>
            <p className="mt-2 text-gray-600">
              CAD/CAM design and architecture solutions for global clients.
            </p>
            <Link to="/engineering" className="text-blue-600 mt-2 block">
              Learn More →
            </Link>
          </div>

          <div className="p-6 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Fabrication</h3>
            <p className="mt-2 text-gray-600">
              Custom wood & acrylic cutting and 3D printing.
            </p>
            <Link to="/fabrication" className="text-blue-600 mt-2 block">
              View Products →
            </Link>
          </div>

          <div className="p-6 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">IT Services</h3>
            <p className="mt-2 text-gray-600">
              Web, mobile apps, and scalable system design.
            </p>
            <Link to="/it-services" className="text-blue-600 mt-2 block">
              Explore →
            </Link>
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="bg-gray-900 text-white text-center py-12">
        <h2 className="text-2xl font-bold">Have a custom requirement?</h2>
        <p className="mt-2">Upload your design and we’ll take care of the rest.</p>

        <Link
          to="/contact"
          className="mt-4 inline-block bg-green-500 px-6 py-2 rounded"
        >
          Get Started
        </Link>
      </section>

    </div>
  );
}
